// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_main__0oiY0 {
  padding: 16px;
}

.banner_successContainer__C40SL {
  padding-top: 12px;
  font-family: Poppins;
  font-weight: 600;
}

.banner_iconContainer__dcxjf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.banner_progressBar__0901W {
  height: 8px;
  width: 200px;
  border-radius: 4px;
  background: #FFFFFF;
}

.banner_progressBarChild__rICAR {
  position: relative;
  left: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 4px;
  height: 8px;
}

.banner_success__b21GP {
  color: #051433;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}

.banner_uploadMessage__YXkoO {
  color: #64748B;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

.banner_buttonContainer__hAn8N {
  display: flex;
  width: 100%;
  padding: 12px 16px;
  background: #F8FAFC;
}

@media screen and (max-width: 1440px) {
  .banner_main__0oiY0 {
    padding: 12px;
  }
  .banner_successContainer__C40SL {
    padding-top: 6px;
  }
  .banner_success__b21GP, .banner_uploadMessage__YXkoO {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/atoms/UploadModal/banner.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,iBAAA;EACA,oBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACG;IACG,aAAA;EACJ;EAEC;IACG,gBAAA;EAAJ;EAGC;IACG,eAAA;EADJ;AACF","sourcesContent":[".main {\n    padding: 16px;\n}\n\n.successContainer {\n    padding-top: 12px;\n    font-family: Poppins;\n    font-weight: 600;\n}\n\n.iconContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    width: 100%;\n}\n\n.progressBar {\n    height: 8px;\n    width: 200px;\n    border-radius: 4px;\n    background:#FFFFFF;\n}\n\n.progressBarChild {\n    position: relative;\n    left: 0;\n    width: 100%;\n    background: #FFFFFF;\n    border-radius: 4px;\n    height: 8px;\n}\n\n.success {\n    color: #051433;\n    font-size: 16px;\n    font-style: normal;\n    line-height: 24px;\n}\n\n.uploadMessage {\n    color: #64748B;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.buttonContainer {\n    display: flex;\n    width: 100%;\n    padding: 12px 16px;\n    background: #F8FAFC;\n}\n\n@media screen and (max-width:1440px) {\n   .main {\n      padding: 12px;\n   }\n\n   .successContainer {\n      padding-top: 6px;\n   }\n\n   .success, .uploadMessage {\n      font-size: 12px;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `banner_main__0oiY0`,
	"successContainer": `banner_successContainer__C40SL`,
	"iconContainer": `banner_iconContainer__dcxjf`,
	"progressBar": `banner_progressBar__0901W`,
	"progressBarChild": `banner_progressBarChild__rICAR`,
	"success": `banner_success__b21GP`,
	"uploadMessage": `banner_uploadMessage__YXkoO`,
	"buttonContainer": `banner_buttonContainer__hAn8N`
};
export default ___CSS_LOADER_EXPORT___;
